import { startLoading, endLoading } from './globalLoading'

/**
 * Higher-order function que envuelve cualquier función asíncrona con manejo automático de loading
 * @param {Function} requestFunction - Función asíncrona a envolver
 * @param {...any} args - Argumentos para pasar a la función
 * @returns {Promise} - Resultado de la función envuelta
 */
export const withLoading = async (requestFunction, ...args) => {
  startLoading()
  try {
    const result = await requestFunction(...args)
    return result
  } finally {
    endLoading()
  }
}

/**
 * Versión que permite personalizar las funciones de start/end loading
 * @param {Function} requestFunction - Función asíncrona a envolver
 * @param {Function} startFn - Función para iniciar loading (opcional)
 * @param {Function} endFn - Función para finalizar loading (opcional)
 * @param {...any} args - Argumentos para pasar a la función
 * @returns {Promise} - Resultado de la función envuelta
 */
export const withCustomLoading = async (requestFunction, startFn = startLoading, endFn = endLoading, ...args) => {
  startFn()
  try {
    const result = await requestFunction(...args)
    return result
  } finally {
    endFn()
  }
}

/**
 * Versión que retorna una función envuelta (para reutilización)
 * @param {Function} requestFunction - Función asíncrona a envolver
 * @param {Function} startFn - Función para iniciar loading (opcional)
 * @param {Function} endFn - Función para finalizar loading (opcional)
 * @returns {Function} - Función envuelta con loading automático
 */
export const createWithLoading = (requestFunction, startFn = startLoading, endFn = endLoading) => {
  return async (...args) => {
    startFn()
    try {
      const result = await requestFunction(...args)
      return result
    } finally {
      endFn()
    }
  }
}

export default withLoading
